import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const navLinks = [
    { to: "/", label: "首页" },
    { to: "/category/romance", label: "分类" },
    { to: "/about", label: "关于我们" },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur-md border-b border-background-200/70"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 text-foreground-950 hover:text-primary-500 transition-colors duration-200"
          >
            <div className="w-8 h-8 flex items-center justify-center">
              <i className="ri-book-read-line text-2xl text-primary-500"></i>
            </div>
            <span className="font-heading text-xl font-bold whitespace-nowrap">
              韩漫漫画网
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`relative text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                  location.pathname === link.to ||
                  (link.to.startsWith("/category") &&
                    location.pathname.startsWith("/category"))
                    ? "text-primary-500"
                    : "text-foreground-700 hover:text-foreground-950"
                }`}
              >
                {link.label}
                {(location.pathname === link.to ||
                  (link.to.startsWith("/category") &&
                    location.pathname.startsWith("/category"))) && (
                  <span className="absolute -bottom-1 left-1/2 -translate-x-1/2 w-5 h-0.5 bg-primary-500 rounded-full" />
                )}
              </Link>
            ))}
            <Link
              to="/category/romance"
              className="bg-primary-500 text-white text-sm font-medium px-5 py-2 rounded-md hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              开始阅读
            </Link>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i
              className={`text-2xl transition-colors ${
                mobileOpen
                  ? "ri-close-line text-foreground-950"
                  : "ri-menu-line text-foreground-700"
              }`}
            ></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-4 flex flex-col gap-3">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`text-sm font-medium py-2 px-3 rounded-md transition-colors ${
                  location.pathname === link.to ||
                  (link.to.startsWith("/category") &&
                    location.pathname.startsWith("/category"))
                    ? "text-primary-500 bg-primary-50"
                    : "text-foreground-700 hover:text-foreground-950 hover:bg-background-100"
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/category/romance"
              className="bg-primary-500 text-white text-sm font-medium text-center py-2.5 rounded-md hover:bg-primary-600 transition-colors"
            >
              开始阅读
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}